export default __webpack_public_path__ + "static/media/slide-page.2822319c.png";